<template>
<div>
	<field :label="label"
		:col-class="colClass"
		v-model="localValue"
		v-on:change="valueChange"
		:params="{type: 'select',options:sortedContactOptions,required:true}"
		v-on:searchChange="contactSearchChange"
		:loading="contactsLoading">
		<small>Start typing to find your contact</small>
	</field>

	<ul v-if="selectMulti" class="list-group mb-4">
		<li v-for="(item,index) in selectedContacts" class="list-group-item list-group-item d-flex justify-content-between">
			{{ item.name }}
			<i v-on:click="removeItem(item.id)" class="fa fa-trash icon-button"></i>
		</li>
	</ul>

</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"

export default {
	name: "ContactSearchSelect",
	components: {
		Field
	},
	props: [
		"label",
		"colClass",
		"value",
		"individualsOnly", //boolean,
		"companiesOnly", //boolean
		"customersOnly", //boolean
		"suppliersOnly",
		'selectMulti', //boolean
		"parentContactId"
	],
	data() {
		return {
			contactsLoading: false,
			localValue: null,
			selectedContactIds: [],
			selectedContacts: []
		}
	},
	watch: {
		value() {
			this.localValue = this.value

			if (this.parentContactId)
				this.fetchSubContacts()
		}
	},
	computed: {
		sortedContactOptions() {
			let options = this.cloneObj(this.$store.contactsIndividuals)

			let customer_id = null
			if (this.recordType == 'project')
				customer_id = this.$store.project.customer_id
			else if (this.recordType == 'service')
				customer_id = this.$store.service.customer_id

			options.sort((a,b) => {
				if (a.contact_id == customer_id)
					return -1
				return 1
			})

			return this.optionify(options,"name")
		},
	},
	methods: {
		valueChange(value) {
			if (this.selectMulti) {
				if (value) {
					this.selectedContactIds.push(value)
					this.localValue = null
					this.fetchSelectedContacts()
					this.$emit('input',this.selectedContactIds)
				}
			}
			else {

				this.$emit('input',value)
			}
		},
		contactSearchChange(value) {
			if (value) {
				this.debounce("fetchFilteredContacts",value,1000)
				this.contactsLoading = true
				
			}
		},
		removeItem(contactId) {
			let index = this.selectedContactIds.findIndex(id => id == contactId)

			if (index >= 0) {
				this.selectedContactIds.splice(index,1)
				this.fetchSelectedContacts()
			}
		},
		fetchSubContacts() {
			let vm = this

			let params = {
				include: [{
					model: "Contact",
					fields: ["name"]
				}],
				filters: [
					["contact_id",this.parentContactId]
				]
			}

			this.getJSON("Contact/get",params).then(response => {
				vm.contactsLoading = false
				if (response.success)
					vm.$store.contactsIndividuals = response.data
			})
		},
		fetchSelectedContacts() {
			let vm = this
			return new Promise((resolve, reject) => {
				if (vm.selectedContactIds.length > 0) {
					let params = {
						filters: [
							["id",vm.selectedContactIds]
						],
						fields: ["id","slug","name"]
					}

					vm.getJSON("Contact/get",params).then(response => {
						if (response.success) {
							vm.selectedContacts = response.data
						}
						resolve(response.data)
					})
				}
				else {
					vm.selectedContacts = []
					resolve([])
				} 
			})
		},
		fetchFilteredContacts(searchTerms) {
			let vm = this

			let filters = [["name",searchTerms,"and","like"]]

			if (this.individualsOnly)
				filters.push(["is_company",0])
			else if (this.companiesOnly)
				filters.push(["is_company",1])

			if (this.customersOnly)
				filters.push(["is_customer",1])
			if (this.suppliersOnly)
				filters.push(["is_supplier",1])

			let params = {
				filters,
				include: [{
					model: "Contact",
					fields: ["name"]
				}]
			}

			this.contactsLoading = true

			this.getJSON("Contact/get",params).then(response => {
				vm.contactsLoading = false
				if (response.success)
					vm.$store.contactsIndividuals = response.data
			})
		},
	},
	created() {
		this.localValue = this.value

		if (this.parentContactId)
			this.fetchSubContacts()
	}
}

</script>